import type { CollectionType } from '@jotta/types/schemas/AlbumSchema'
export type CollectionTypeKey = keyof typeof CollectionType
export type AlbumListQueryKey<T extends CollectionTypeKey = CollectionTypeKey> =
  readonly [key: 'albumList', albumType: T]
export function getAlbumListQueryKey<T extends CollectionTypeKey>(
  albumType: T,
): AlbumListQueryKey<T> {
  return ['albumList', albumType]
}
